import { render, staticRenderFns } from "./FlashSaleRemarks.vue?vue&type=template&id=4f2d9503&scoped=true&"
import script from "./FlashSaleRemarks.vue?vue&type=script&lang=js&"
export * from "./FlashSaleRemarks.vue?vue&type=script&lang=js&"
import style0 from "./FlashSaleRemarks.vue?vue&type=style&index=0&id=4f2d9503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2d9503",
  null
  
)

export default component.exports